import { type FC, Fragment } from 'react';
import {
  Alert,
  Divider,
  Modal,
  ModalBody,
  ModalHeader
} from '@cencosud-cencommerce/paris-uikit';

import type { ProductServiceItemProps } from '../ProductServiceItem/ProductsServiceItem';
import ProductServiceItem from '../ProductServiceItem/ProductsServiceItem';

interface Props {
  'data-testid'?: string;
  isOpen: boolean;
  onClose: VoidFunction;
  services: ProductServiceItemProps[];
}

const ProductServicesModal: FC<Props> = ({
  'data-testid': dataTestId = 'paris-modal-product-services',
  isOpen,
  onClose,
  services
}) => {
  return (
    <Modal data-testid={dataTestId} isOpen={isOpen} size="sm">
      <ModalHeader
        onClose={onClose}
        title="Servicios asociados"
        icon={{
          name: 'shopping-bag',
          fill: 'primary-500'
        }}
      />
      <ModalBody className="co-px-6 co-mt-6">
        <div className="co-flex co-flex-col co-gap-4">
          {services?.map((service, index) => (
            <Fragment key={index}>
              <ProductServiceItem
                className="co-p-3"
                {...service}
              ></ProductServiceItem>
              {services.length > index + 1 && <Divider />}
            </Fragment>
          ))}
        </div>
        <Alert
          status="info"
          body="Te enviaremos un correo para agendar los servicios"
        ></Alert>
      </ModalBody>
    </Modal>
  );
};

export default ProductServicesModal;
